module.exports = __webpack_public_path__ + "img/41400.47634aa0.jpg";